<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="workOrdersFiltered"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    style="background-color: #eeeeee"
                >
                    <h1 class="mx-4">WORK ORDERS</h1>
                    <v-btn rounded color="primary" @click="findWO = true">
                        <v-icon class="mr-1">
                            mdi-database-search
                        </v-icon>
                        FIND
                    </v-btn>
                    <v-spacer />
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.code`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="search"
                    dense
                />
            </template>
            <template v-slot:[`header.project`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="projectToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.type`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="typeToFilter"
                    dense
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.createdBy`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">{{ item.createdBy.name }}</p>
                </div>
            </template>
            <template v-slot:[`item.project`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.project?.reference }} - {{ item.project?.name }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.productionStart`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{
                            item.productionStart
                                ? formatDate(item.productionStart.seconds)
                                : ''
                        }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.type`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.assemblyWorkOrder ? 'Assembly' : 'Production' }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.weight`]="{ item }">
                <div class="d-flex justify-end">
                    <p class="my-0">{{ (item.weight || 0).toFixed(1) }} kg</p>
                </div>
            </template>
            <template v-slot:[`item.packing`]="{ item }">
                <p>
                    {{ packingProgress(item) }}
                </p>
            </template>
            <template v-slot:[`item.quality`]="{ item }">
                <div>
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <v-col>
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #2b81d6;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{ calculateWOPending(item) }}
                                    </p>
                                </v-btn>
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #2fbf56;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{ calculateWOReleased(item) }}
                                    </p>
                                </v-btn>
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #ffa41d;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{ calculateWOReprocess(item) }}
                                    </p>
                                </v-btn>
                                <v-btn
                                    x-small
                                    icon
                                    class="mr-1"
                                    color="white"
                                    style="background-color: #FF2610;"
                                    v-on="on"
                                >
                                    <p class="my-0">
                                        {{ calculateWORejected(item) }}
                                    </p>
                                </v-btn>
                            </v-col>
                        </template>
                        <span>
                            Pending :
                            {{ calculateWOPending(item) || 0 }}
                            <br />
                            Released :
                            {{ calculateWOReleased(item) }} <br />
                            Reprocess :
                            {{ calculateWOReprocess(item) }} <br />
                            Rejected :
                            {{ calculateWORejected(item) }} <br />
                        </span>
                    </v-tooltip>
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu rounded offset-y>
                    <template v-slot:activator="{ attrs, on }">
                        <v-btn
                            fab
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="grey lighten-3"
                            depressed
                            class="mx-1"
                        >
                            <v-icon>mdi-dots-horizontal</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click.stop="openProcessWorkOrder(item)">
                            <v-list-item-icon>
                                <v-icon size="20">mdi-eye</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    View
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-if="productionClosingPermission"
                            @click.stop="openProductionClosing(item)"
                        >
                            <v-list-item-icon>
                                <v-icon size="20"
                                    >mdi-package-variant-closed-check</v-icon
                                >
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Close Production
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
        <!--PROCESS WORK ORDER-->
        <v-dialog
            v-model="processWorkOrder"
            :retain-focus="false"
            persistent
            fullscreen
        >
            <OperatorProcessWorkOrder
                v-if="processWorkOrder"
                :order="selectedOrder"
                @close="closeProcessWorkOrder"
            />
        </v-dialog>
        <!--FIND WO-->
        <v-dialog
            v-model="findWO"
            :retain-focus="false"
            persistent
            max-width="600"
        >
            <FindWO v-if="findWO" @addWO="addWO" @close="findWO = false" />
        </v-dialog>
        <!-- close work order -->
        <v-dialog v-model="productionClosing" persistent max-width="400px">
            <v-card :loading="loading">
                <v-card-title class="text-h5">Close Work Order</v-card-title>
                <v-card-text>
                    Are you sure you want to close this work order?
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="closeProductionClosing"
                    >
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="closeWO"
                        text
                        color="primary"
                        :loading="loading"
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { firestore } from '@/services/firebase'
import API from '@/services/api'
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import WOMethods from './WOMethods.js'

export default {
    name: 'operatorsFinishedWorkOrders',
    props: {},
    components: {
        OperatorProcessWorkOrder: () =>
            import('@/components/WorkOrders/OperatorProcessWorkOrder.vue'),
        FindWO: () => import('@/components/WorkOrders/FindWO.vue'),
    },
    data: () => ({
        selectedOrder: undefined,
        processWorkOrder: false,
        projectToFilter: undefined,
        typeToFilter: undefined,
        loading: false,
        workOrders: [],
        search: null,
        headers: [
            {
                text: 'ORDER',
                value: 'code',
                align: 'center',
                sortable: false,
                width: 120,
            },
            {
                text: 'CREATED BY',
                value: 'createdBy',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PROJECT',
                value: 'project',
                align: 'center',
                sortable: false,
                width: 240,
            },
            {
                text: 'PRODUCTION START',
                value: 'productionStart',
                align: 'center',
                sortable: false,
            },
            {
                text: 'TYPE',
                value: 'type',
                align: 'center',
                sortable: false,
            },
            {
                text: 'NOTES',
                value: 'notes',
                align: 'center',
                sortable: false,
            },
            {
                text: 'WEIGHT',
                value: 'weight',
                align: 'right',
                sortable: false,
            },
            {
                text: 'QUALITY',
                value: 'quality',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PACKING',
                value: 'packing',
                align: 'center',
                sortable: false,
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        listener: undefined,
        companyId: JSON.parse(localStorage.getItem('company')),
        resourceId: undefined,
        settingProcesses: undefined,
        findWO: false,
        user: {},
        productionClosingPermission: false,
        productionClosing: false,
        qualityProcess: {
            id: 'quality',
            name: 'Quality',
        },
        packingProcess: {
            id: 'packing',
            name: 'Packing',
        },
        users: {},
        projects: {},
        woMethods: new WOMethods(),
        deletedWorkOrdersIds: [],
    }),
    computed: {
        ...mapState(['notificationResource']),
        workOrdersFiltered() {
            this.openResource()
            let conditions = []
            if (this.search) {
                conditions.push(this.filterOrder)
            }
            if (this.projectToFilter) {
                conditions.push(this.filterProject)
            }
            if (this.typeToFilter) {
                conditions.push(this.filterByType)
            }
            if (conditions.length > 0) {
                return this.workOrders.filter(order => {
                    return conditions.every(condition => {
                        return condition(order)
                    })
                })
            }
            this.sort()
            return this.workOrders
        },
    },
    watch: {
        notificationResource: function(resource) {
            if (resource) {
                this.resourceId = resource
                this.openResource()
                this.setNotificationResource(undefined)
            }
        },
    },
    async mounted() {
        try {
            this.loading = true
            this.resourceId = this.$route.query.resourceId
            const {
                data: { user },
            } = await API.getMyInfo()
            this.user = user
            // set permission
            this.productionClosingPermission = user.permissions.includes(
                'closeWO'
            )

            const {
                data: { settings },
            } = await API.getSettings()
            this.settingProcesses = settings.find(s => s.name == 'Processes')
            this.projects = await API.getWoProjects()
            const {
                data: { users },
            } = await API.getWoUsers()
            this.users = users
            await this.getWOFromSDK()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    beforeDestroy() {
        if (this.listener) {
            this.listener()
            this.listener = null
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        ...mapActions(['setNotificationResource']),
        ...mapGetters(['getNotificationResource']),
        async closeWO() {
            try {
                this.loading = true
                await API.closeWorkOrder({
                    workOrderId: this.selectedOrder.id,
                    notificationId: 'ar0vX28u4hadZW2pVn9n',
                })
                this.workOrders = this.workOrders.filter(
                    order => order.id != this.selectedOrder.id
                )
                this.closeProductionClosing()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeProductionClosing() {
            this.selectedOrder = {}
            this.productionClosing = false
        },
        openProductionClosing(workOrder) {
            this.selectedOrder = _.cloneDeep(workOrder)
            this.productionClosing = true
        },
        openProcessWorkOrder(item) {
            this.selectedOrder = _.cloneDeep(item)
            this.processWorkOrder = true
        },
        closeProcessWorkOrder() {
            this.processWorkOrder = false
        },
        filterOrder(order) {
            return order.code.toLowerCase().includes(this.search.toLowerCase())
        },
        filterProject(order) {
            return (
                order.project?.name
                    .toLowerCase()
                    .includes(this.projectToFilter.toLowerCase()) ||
                order.project?.reference
                    .toString()
                    .toLowerCase()
                    .includes(this.projectToFilter.toLowerCase())
            )
        },
        filterByType(order) {
            const type = order.assemblyWorkOrder ? 'assembly' : 'production'
            return type.includes(this.typeToFilter.toLowerCase())
        },
        formatDate(seconds) {
            return `${moment.unix(seconds).format('L')} ${moment
                .unix(seconds)
                .format('LT')}`
        },
        sort() {
            this.workOrders.sort(
                (a, b) =>
                    (b.createdOn.seconds || b.createdOn._seconds) -
                    (a.createdOn.seconds || a.createdOn._seconds)
            )
        },
        openResource() {
            if (this.resourceId) {
                const resource = this.workOrders.find(
                    w => w.id == this.resourceId
                )
                if (resource) {
                    this.resourceId = undefined
                    this.openProcessWorkOrder(resource)
                }
            }
        },
        async addWO(wo) {
            try {
                this.loading = true
                const index = this.workOrders.findIndex(w => w.id == wo.id)
                if (index >= 0) {
                    this.openProcessWorkOrder(this.workOrders[index])
                } else {
                    wo.project = this.projects[wo.projectId] || {}
                    if (!wo.project || Object.keys(wo.project).length == 0) {
                        wo.project = await API.getProject(wo.projectId)
                        this.projects[wo.projectId] = wo.project
                    }
                    wo.projectManager =
                        this.users[wo.project.projectManager] || {}
                    wo.creator = this.users[wo.createdBy] || {}
                    wo.approvedBy = this.users[wo.approvedBy] || {}
                    this.woMethods.formatItems(wo)
                    this.setProcessesInfo(wo)
                    this.workOrders.splice(0, 0, wo)
                    this.openProcessWorkOrder(wo)
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        calculateWOPending(wo) {
            try {
                let totalPending = 0
                wo.items.forEach(item => {
                    let pendingQty = 0
                    let lastProcessIndex = item.processes.length - 1
                    if (wo.assemblyWorkOrder != undefined) {
                        lastProcessIndex =
                            item.processes.findIndex(
                                p => p == this.qualityProcess.id
                            ) - 1
                    }
                    if (lastProcessIndex > -1) {
                        const lastProductionProcess =
                            item.processes[lastProcessIndex]
                        if (item.production) {
                            const production = item.production.filter(
                                entry =>
                                    entry.process.id == lastProductionProcess
                            )
                            if (production.length > 0) {
                                pendingQty = production.reduce(
                                    (accumulator, entry) =>
                                        accumulator + entry.qty,
                                    0
                                )
                            }
                        }
                        if (item.quality) {
                            const rejected = item.quality.reduce(
                                (accumulator, entry) =>
                                    accumulator + (entry.rejectQty || 0),
                                0
                            )
                            const released = item.quality.reduce(
                                (accumulator, entry) =>
                                    accumulator + (entry.releaseQty || 0),
                                0
                            )
                            pendingQty -=
                                Number(released || 0) + Number(rejected || 0)
                        }
                    }
                    totalPending += pendingQty
                })

                return totalPending
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateWOReleased(wo) {
            try {
                let totalReleased = 0
                wo.items.forEach(item => {
                    let released = 0
                    if (item.quality) {
                        const value = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.releaseQty || 0),
                            0
                        )
                        released += Number(value || 0)
                    }
                    totalReleased += released
                })
                return totalReleased
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateWOReprocess(wo) {
            try {
                let totalReprocess = 0
                wo.items.forEach(item => {
                    let reprocess = 0
                    if (item.quality) {
                        const value = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.reprocessQty || 0),
                            0
                        )
                        reprocess += Number(value || 0)
                    }
                    totalReprocess += reprocess
                })

                return totalReprocess
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateWORejected(wo) {
            try {
                let totalRejected = 0
                wo.items.forEach(item => {
                    let rejected = 0
                    if (item.quality) {
                        const value = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.rejectQty || 0),
                            0
                        )
                        rejected += Number(value || 0)
                    }
                    totalRejected += rejected
                })

                return totalRejected
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        packingProgress(workOrder) {
            let total = 0
            let packed = 0

            if (workOrder.items) {
                workOrder.items.forEach(item => {
                    total += +item.quantity
                    packed += +item.packedQty || 0
                })
            }

            const percentage = total > 0 ? (packed / total) * 100 : 100
            return `${packed}/${total} ${percentage.toFixed(2)}%`
        },
        setProcessesInfo(wo) {
            wo.processesInfo = []
            let qualityProcess = {
                process: {
                    id: this.qualityProcess.id,
                    name: this.qualityProcess.name,
                },
                qty: 0,
                received: 0,
                delivered: 0,
                produced: 0,
                available: 0,
            }

            let packingProcess = {
                process: {
                    id: this.packingProcess.id,
                    name: this.packingProcess.name,
                },
                qty: 0,
                received: 0,
                delivered: 0,
                produced: 0,
                available: 0,
            }

            let showDefaultProcesses = false
            const items = wo.items || []
            items.forEach(item => {
                if (item?.processes) {
                    item.processes.forEach(process => {
                        let processInfo = wo.processesInfo.find(
                            info => info.process.id == process
                        )

                        if (!processInfo) {
                            let totalDelivered = item.deliveries
                                ? item.deliveries.reduce(
                                      (total, register) =>
                                          register.prevProcess.id == process
                                              ? total + register.qty
                                              : total,
                                      0
                                  )
                                : 0
                            let totalProduced = item.production
                                ? item.production.reduce(
                                      (total, register) =>
                                          register.process.id == process
                                              ? total + register.qty
                                              : total,
                                      0
                                  )
                                : 0

                            let received = item.deliveries
                                ? item.deliveries.filter(
                                      register =>
                                          register.nextProcess.id == process &&
                                          register.receivedBy
                                  )
                                : []
                            let totalReceived = received.reduce(
                                (total, register) => total + register.qty,
                                0
                            )
                            let processIndex = this.settingProcesses.processes.findIndex(
                                p => p.id == process
                            )

                            const pIndex = item.processes.findIndex(
                                p => p == process
                            )
                            if (pIndex == 0) {
                                totalReceived = item.quantity
                            }
                            if (processIndex > -1) {
                                wo.processesInfo.push({
                                    process: {
                                        id: this.settingProcesses.processes[
                                            processIndex
                                        ].id,
                                        name: this.settingProcesses.processes[
                                            processIndex
                                        ].name,
                                    },
                                    qty: item.quantity,
                                    delivered: totalDelivered,
                                    produced: totalProduced,
                                    received: totalReceived,
                                    available: totalReceived - totalProduced,
                                })
                            } else {
                                if (process == this.qualityProcess.id) {
                                    wo.processesInfo.push({
                                        process: this.qualityProcess,
                                        qty: item.quantity,
                                        delivered: totalDelivered,
                                        produced: totalProduced,
                                        received: totalReceived,
                                        available:
                                            totalReceived - totalProduced,
                                    })
                                } else if (process == this.packingProcess.id) {
                                    wo.processesInfo.push({
                                        process: this.packingProcess,
                                        qty: item.quantity,
                                        delivered: totalDelivered,
                                        produced: totalProduced,
                                        received: totalReceived,
                                        available:
                                            totalReceived - totalProduced,
                                    })
                                }
                            }
                        } else {
                            processInfo.qty += item.quantity
                            processInfo.delivered += item.deliveries
                                ? item.deliveries.reduce(
                                      (total, register) =>
                                          register.prevProcess.id == process
                                              ? total + register.qty
                                              : total,
                                      0
                                  )
                                : 0
                            processInfo.produced += item.production
                                ? item.production.reduce(
                                      (total, register) =>
                                          register.process.id == process
                                              ? total + register.qty
                                              : total,
                                      0
                                  )
                                : 0

                            const receivedEntries = item.deliveries
                                ? item.deliveries.filter(
                                      e => e.nextProcess == process
                                  )
                                : []

                            processInfo.received += receivedEntries.reduce(
                                (total, register) => total + register.qty,
                                0
                            )
                        }
                    })

                    let totalReceivedNew = item.deliveries
                        ? item.deliveries.reduce(
                              (total, register) =>
                                  register.nextProcess.id ==
                                      this.packingProcess.id &&
                                  register.receivedBy
                                      ? total + register.qty
                                      : total,
                              0
                          )
                        : 0

                    let totalReceivedOld = item.deliveries
                        ? item.deliveries.reduce(
                              (total, register) =>
                                  register.nextProcess.id ==
                                      this.packingProcess.id &&
                                  register.receivedBy
                                      ? total + register.qty
                                      : total,
                              0
                          )
                        : 0

                    let totalReceived = totalReceivedOld + totalReceivedNew

                    packingProcess.qty += item.quantity
                    packingProcess.delivered = 'NA'
                    packingProcess.produced += item.packedQty
                    packingProcess.available =
                        totalReceived - (packingProcess.produced || 0)

                    //quality process
                    qualityProcess.qty += item.quantity
                    qualityProcess.delivered = 'NA'
                    qualityProcess.produced =
                        this.calculateRejectedQty(item) +
                        this.calculateReleasedQty(item)
                    qualityProcess.available = this.calculateQualityPending(
                        item,
                        wo
                    )
                }
            })
            if (showDefaultProcesses) {
                wo.processesInfo.push(qualityProcess)
                wo.processesInfo.push(packingProcess)
            }
            if (this.selectedOrder && this.selectedOrder.id == wo.id) {
                this.selectedOrder = _.cloneDeep(wo)
            }
        },
        calculateQualityPending(item, workOrder) {
            try {
                let pendingQty = 0
                let lastProcessIndex = item.processes.length - 1
                if (workOrder.assemblyWorkOrder != undefined) {
                    lastProcessIndex =
                        item.processes.findIndex(
                            p => p == this.qualityProcess.id
                        ) - 1
                }
                if (lastProcessIndex > -1) {
                    const lastProductionProcess =
                        item.processes[lastProcessIndex]
                    if (item.production) {
                        const production = item.production.filter(
                            entry => entry.process.id == lastProductionProcess
                        )
                        if (production.length > 0) {
                            pendingQty = production.reduce(
                                (accumulator, entry) => accumulator + entry.qty,
                                0
                            )
                        }
                    }
                    if (item.quality) {
                        const rejected = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.rejectQty || 0),
                            0
                        )
                        const released = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.releaseQty || 0),
                            0
                        )
                        pendingQty -=
                            Number(released || 0) + Number(rejected || 0)
                    }
                }
                return pendingQty
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateReleasedQty(item) {
            try {
                let released = 0
                if (item.quality) {
                    const value = item.quality.reduce(
                        (accumulator, entry) =>
                            accumulator + (entry.releaseQty || 0),
                        0
                    )
                    released += Number(value || 0)
                }
                return released
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateRejectedQty(item) {
            try {
                let rejected = 0
                if (item.quality) {
                    const value = item.quality.reduce(
                        (accumulator, entry) =>
                            accumulator + (entry.rejectQty || 0),
                        0
                    )
                    rejected += Number(value || 0)
                }
                return rejected
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        async loadAllActiveWorkOrders() {
            return await this.woMethods.loadAllActiveWorkOrders(
                this.companyId,
                ['finished', 'approved', 'closed']
            )
        },
        async getWOFromSDK() {
            try {
                this.loading = true

                let startDate = new Date()

                // Query with status filter only (readAllWO filtered in code)
                // Note: OperatorsFinishedWorkOrders only shows 'finished' status
                let query = firestore
                    .collection('companies')
                    .doc(this.companyId)
                    .collection('workOrders')
                    .where('status', 'in', ['finished', 'approved', 'closed'])
                    .where('updatedOn', '>=', startDate)

                // Load initial data from backup
                let initialData = await this.loadAllActiveWorkOrders()

                let data = []
                //filter by status
                initialData = initialData.filter(wo =>
                    ['finished'].includes(wo.status)
                )
                for (let wo of initialData) {
                    wo = await this.formatWorkOrder(wo)
                    if (wo) {
                        data.push(wo)
                    }
                }

                this.workOrders = data
                this.workOrders.forEach(wo => {
                    this.woMethods.formatItems(wo)
                    this.setProcessesInfo(wo)
                })

                this.listener = query.onSnapshot(async snapshot => {
                    const changes = Array.from(snapshot.docChanges())
                    const processedChanges = await Promise.all(
                        changes.map(async change => {
                            let wo = Object.assign(change.doc.data(), {
                                id: change.doc.id,
                            })
                            wo = await this.formatWorkOrder(wo)
                            return { change, wo }
                        })
                    )

                    // Process all changes after all have been formatted
                    processedChanges.forEach(({ change, wo }) => {
                        if (wo) {
                            if (
                                change.type === 'added' ||
                                change.type === 'modified'
                            ) {
                                const index = data.findIndex(w => w.id == wo.id)
                                if (index >= 0) {
                                    // Use $set to ensure Vue reactivity
                                    this.$set(data, index, wo)
                                } else {
                                    data.push(wo)
                                }
                            }
                            if (
                                change.type === 'removed' ||
                                wo.status !== 'finished'
                            ) {
                                const index = data.findIndex(w => w.id == wo.id)
                                if (index >= 0) {
                                    data.splice(index, 1)
                                }
                            }
                        }
                    })
                    // Force array update to ensure reactivity
                    this.workOrders = [...data]
                    this.workOrders.forEach(wo => {
                        this.woMethods.formatItems(wo)
                        this.setProcessesInfo(wo)
                    })

                    // update selectedOrder if it's currently open
                    if (this.selectedOrder && this.selectedOrder.id) {
                        const updatedOrder = this.workOrders.find(
                            wo => wo.id == this.selectedOrder.id
                        )
                        if (updatedOrder) {
                            this.selectedOrder = _.cloneDeep(updatedOrder)
                        }
                    }
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async formatWorkOrder(wo) {
            try {
                const workOrder = wo

                // Filter by status (already in query, but double check)
                // OperatorsFinishedWorkOrders only shows 'finished' status
                if (
                    !['finished', 'approved', 'closed'].includes(
                        workOrder.status
                    )
                ) {
                    return undefined
                }

                // Filter by readAllWO permission in code (not in query)
                if (
                    !this.user?.permissions?.includes('readAllWO') &&
                    workOrder.createdBy != this.user.id
                ) {
                    return undefined
                }

                // set created by
                const user = this.users[workOrder.createdBy]
                if (user) {
                    workOrder.createdBy = user
                } else {
                    workOrder.createdBy = {
                        id: workOrder.createdBy,
                        name: '',
                        permissions: [],
                        process: [],
                    }
                    // add user if not exist
                    this.users[workOrder.createdBy] = workOrder.createdBy
                }

                // get or fetch project
                workOrder.project = this.projects[workOrder.projectId] || {}
                if (
                    !workOrder.project ||
                    Object.keys(workOrder.project).length == 0
                ) {
                    workOrder.project = await API.getProject(
                        workOrder.projectId
                    )
                    // add project to projects object
                    this.projects[workOrder.projectId] = workOrder.project
                }

                // Format items
                const formattedWO = this.woMethods.formatItems(workOrder)
                return formattedWO || workOrder
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
                return undefined
            }
        },
    },
}
</script>

<style>
.v-input .v-label {
    font-size: 12px;
}
</style>
